export const TRANSLATIONS_EN = {
  11100: "Continuous Urban Fabric (S.L. > 80%)",
  11210: "Discontinuous Dense Urban Fabric (S.L. : 50% - 80%)",
  11220: "Discontinuous Medium Density Urban Fabric (S.L. : 30% - 50%)",
  11230: "Discontinuous Low Density Urban Fabric (S.L. : 10% - 30%)",
  11240: "Discontinuous Very Low Density Urban Fabric (S.L. < 10%)",
  11300: "Isolated Structures",
  12100: "Industrial, commercial, public, military and private units",
  12210: "Fast transit roads and associated land",
  12220: "Other roads and associated land",
  12230: "Railways and associated land",
  12300: "Port areas",
  12400: "Airports",
  13100: "Mineral extraction and dump sites",
  13300: "Construction sites",
  13400: "Land without current use",
  14100: "Green urban areas",
  14200: "Sports and leisure facilities",
  21000: "Arable land (annual crops)",
  22000: "Permanent crops (vineyards, fruit trees, olive groves)",
  23000: "Pastures",
  24000: "Complex and mixed cultivation patterns",
  25000: "Orchards at the fringe of urban classes",
  31000: "Forests",
  32000: "Herbaceous vegetation associations (natural grassland, moors...)",
  33000:
    "Open spaces with little or no vegetations (beaches, dunes, bare rocks, glaciers)",
  40000: "Wetland",
  50000: "Water bodies",
  noInfo: "No information",
  showListCatnat: "Show the complete list",
  hideListCatnat: "Hide the complete list",
  showCompleteList: "Here is the complete list of CATNAT",
  showLatestListByCategory:
    "Here is the list of the latest CATNAT by categories",
  address: "Address",
  startDate: "Date début arrêté",
  endDate: "Date fin arrêté",
  url: "Link URL",
  noPeril: "There are no peril notices near this address!",
  noCatnat: "There are no catnat notices near this address!",
  addPeril: "Add/Modify a peril",
  noSeveso: "There are no site seveso notices near this address!",
  "settings": {
    "title": "Settings",
    "tab": {
      "exclusionZones": "Exclusion zones",
    }
  },
  "applicationMenu": {
    "menuSelectionLabel": "Go to",
    "menuItem": {
      "data4home": "Data4Home",
      "data4home2": "Data4Home (New)",
      "addressBulk": "Address Bulk",
      "riskEditor": "Risk Editor",
      "settings": "Exclusion zones",
      "data4weather": "Data4Weather",
    }
  },
  "weatherScreen": {
    "requestFilterLabel": "Request filters",
    "localFilterLabel": "Loaded alerts filters",
    "loadYellowAlertLabel": "Load Yellow alerts",
    "plusMinusOneDayLabel": "+ / - 1 day",
    "allLabel": "All",
    "geocoderPlaceHolder": "Search for a postal code",
    "alertDetails": "Alert details",
    "tabs": {
      "map": "Map",
      "alertSummary": "Summary",
      "alertTable": "Table",
      "api": "API"
    },
    "noAlertsMessage": "No alerts match your search criteria",
    "minOneTypeRequired": "You must select at least one alert type to see results",
    "fetchError": "Error while fetching weather alerts",
    "retryLabel": "Retry",
  },
  "searchLabel": "Search",
  "fireStation": {
    "tileShortLabel": "Fire station distance",
    "tileLabel": "Road distance from the nearest fire station",
    "terrainDescription": "Elevation, land use, nearest waterway, railway, nearby fire station and gas station.",
    "panelTitle": "FIRE STATION",
    "empty": "No fire station found",
    "name": "Name",
    "operator": "Operator",
    "distance": "Distance",
    "type": "Station type",
    "notProvided": "not provided",
    "bulkColumn": "Nearest fire station (distance and name)"
  },
  "addressBulk": {
    "generatePdfLabel": "Also generate the PDFs",
    "generatePdfLimit": "One PDF is generated per address, up to {{count}} per file.",
    "generatePdfFileTooLarge": "This file contains {{count}} addresses: PDF generation is limited to {{max}} addresses.",
    "generatePdfTeasing": "This option adds one full PDF per address inside a ZIP together with the spreadsheet report. A higher access level is required to enable it.",
    "pdfRowCapExceeded": "The file exceeds the maximum number of addresses allowed for PDF generation.",
    "bundleFileSubtitle": "Report + 1 PDF per address"
  },
  "gasStation": {
    "tileShortLabel": "Nearby gas station",
    "tileLabel": "Gas station within {{radius}} meters of the building polygon",
    "tileLabelFallback": "Gas station near the building polygon",
    "panelTitle": "GAS STATION",
    "empty": "No gas station near the building",
    "name": "Name",
    "brand": "Brand",
    "operator": "Operator",
    "address": "Address",
    "openingHours": "Opening hours",
    "distance": "Distance to the building",
    "phone": "Phone",
    "website": "Website",
    "fuelsTitle": "Fuels",
    "servicesTitle": "Services",
    "fuels": {
      "diesel": "Diesel",
      "sp95": "SP95",
      "e10": "SP95-E10",
      "sp98": "SP98",
      "e85": "E85",
      "lpg": "LPG",
      "adblue": "AdBlue",
      "cng": "CNG",
      "electricity": "Electricity",
      "gnr": "Off-road diesel"
    },
    "services": {
      "selfService": "Self-service",
      "carWash": "Car wash",
      "toilets": "Toilets",
      "shop": "Shop",
      "atm": "ATM",
      "compressedAir": "Compressed air",
      "wheelchair": "Wheelchair access",
      "hgv": "HGV"
    },
    "serviceValues": {
      "gas": "gas station shop",
      "fuel": "fuel",
      "convenience": "convenience store"
    }
  }
};
